import { configureStore } from '@reduxjs/toolkit';

import { environment } from '@paragon/environment-tools';
import { logInData } from '@paragon/login-tools';
import { notifications } from '@paragon/notification-tools';
import { spinnerMessages } from '@paragon/task-spinner';
import { theme } from '@paragon/themes';

export const store = configureStore({
  reducer: {
    spinnerMessages,
    logInData,
    environment,
    notifications,
    theme,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
